import React from 'react'
import shortid from 'shortid'

export default function useUUID () {
  return React.useState(shortid.generate)
}
